import { userApi } from '@sellsen/generated-sources';
import { useQuery } from '@tanstack/react-query';
const QUERY_KEYS = {
    all: ['user'],
    getCurrentUser: () => [...QUERY_KEYS.all, 'me'],
};
export const USER_QUERY_KEYS = QUERY_KEYS;
export const useGetCurrentUserQuery = () => {
    return useQuery({
        queryKey: QUERY_KEYS.getCurrentUser(),
        queryFn: () => {
            return userApi.getCurrentUser();
        },
    });
};
